<template>
    <div class="referral-container">
        <van-action-sheet v-model="showBank" :actions="actions" cancel-text=""
            :description="this.$t('cash.chooseWallet')" close-on-click-action @select="onSelect" />
        <div v-if="setPwd" class="real_name_mask" @click="setPwd = false">
            <div class="real_box" @click.stop>
                <div class="tit" />
                <p class="tips" style="font-size: 16px; ">
                    {{ $t('cash.setPwdFirst') }}
                </p>
                <div class="basic_btn" @click="setIniPwd">
                    <span style="color: #ffffff;"> {{ $t('cash.setNow') }}</span>
                </div>
            </div>
        </div>
        <van-popup v-model="write_psd" closeable close-icon="close" round position="bottom">
            <div class="psw_box">
                <van-password-input :value="psd_val" :mask="true" :focused="showKeyboard"
                    @focus="showKeyboard = true" />
                <div class="keybord_box">
                    <div class="keybord">
                        <div class="key_item" v-for="i in 9" @click="onInput(i)">
                            <div class="key_inner">{{ i }}</div>
                        </div>
                        <div class="key_item no_bg">
                            <div class="key_inner"></div>
                        </div>
                        <div class="key_item" @click="onInput(0)">
                            <div class="key_inner">0</div>
                        </div>
                        <div class="key_item no_bg x" @click="onDelete">
                            <div class="key_inner">x</div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 会员等级 -->
        <van-popup v-model="showLevel" position="right">
            <div class="main-box">
                <div class="personal-data-page">
                    <!-- 顶部导航 -->
                    <div class="title-box">
                        <button class="back" @click="showLevel = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2>{{ $t('Rules') }}</h2>
                    </div>

                    <div class="level-box">
                        <div class="title">
                            <div class="t">
                                {{ $t('Level') }}
                            </div>
                            <div class="t">
                                {{ $t('commissionRate') }}({{ $t('Reinvestment') }})
                            </div>
                            <div class="t">
                                {{ $t('invitation') }}
                            </div>
                            <div class="t">
                                {{ $t('存款金额') }}
                            </div>
                        </div>
                        <div class="lis" v-for="(item, index) in levelList" :key="index">
                            <div class="t">
                                <span class="logos" :class="'logo-' + Number(index + 1)">
                                    {{ item.level == 10 ?'SVIP': 'Lv.'+item.level }}
                                </span>
                                <span style="color: #eee;font-size: 14px;font-weight: bold;">{{ $t('Level') }}</span>
                            </div>
                            <div class="t-boxs">
                                <span><i style="font-size: 10px;color: #99A9A6;">N1</i>:{{ item.one_commission
                                }}%</span>
                                <span class="qq"><i class="iconfont icon-zhongzhi"></i> {{ item.one_commission / 2
                                }}%</span>
                                <span><i style="font-size: 10px;color: #99A9A6;">N2</i>:{{ item.two_commission
                                }}%</span>
                                <span class="qq"><i class="iconfont icon-zhongzhi"></i> {{ item.two_commission / 2
                                }}%</span>
                                <span><i style="font-size: 10px;color: #99A9A6;">N3</i>:{{ item.three_commission
                                }}%</span>
                                <span class="qq"><i class="iconfont icon-zhongzhi"></i> {{ item.three_commission / 2
                                }}%</span>
                            </div>
                            <div class="t-boxs">
                                <span class="green">{{ item.number_invitees_min }}-{{ item.number_invitees_max }}</span>
                                <span>{{ $t('invitation') }}</span>
                            </div>
                            <div class="t-boxs">
                                <span class="yellow">{{ item.investment_amount ? item.investment_amount : '-' }}</span>
                                <span>{{ $cut2 }}</span>
                            </div>
                        </div>
                        <div style="height: 50px;"></div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 右边弹框 -->
        <van-popup v-model="show" position="right">
            <div class="main-box">
                <div class="personal-data-page">
                    <!-- 顶部导航 -->
                    <div class="title-box">
                        <button class="back" @click="show = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2>{{ $t('Details') }}</h2>
                    </div>
                    <div class="list-info-box" v-if="info != null">
                        <div class="boxs">
                            <span class="t">
                                {{ info.invite_num || 0 }}
                            </span>
                            <span class="t2">
                                {{ $t('Registered') }}
                            </span>
                        </div>
                        <div class="boxs">
                            <span class="t">
                                {{ info.invite_investment_num || 0 }}
                            </span>
                            <span class="t2">
                                {{ $t('Usersinvestments') }}
                            </span>
                        </div>
                        <div class="boxs">
                            <span class="t">
                                {{ info.invite_investment_amount || 0 }}
                            </span>
                            <span class="t2">
                                {{ $t('TotalAmount') }}
                            </span>
                        </div>
                    </div>
                    <div class="list-box">
                        <div class="t">
                            {{ $t('Details') }}
                        </div>
                        <div class="uls">
                            <div class="title">
                                <div class="h">
                                    {{ $t('Account') }}
                                </div>
                                <div class="h">
                                    {{ $t('Investments') }}
                                </div>
                                <div class="h">
                                    {{ $t('NumberSubscriptions') }}
                                </div>
                            </div>
                            <div class="lis" v-for="(item, index) in list" :key="index">
                                <div class="h">
                                    {{ formatNumber(item.user_name) }}
                                </div>
                                <div class="h">
                                    {{ item.total_investment_amount }}
                                </div>
                                <div class="h">
                                    {{ item.investment_number }}
                                </div>
                            </div>
                            <div class="lis" v-if="list.length === 0">
                                <div class="errs-msg">
                                    {{ $t('Nousersfound') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="height: 50px;"></div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showWithdraw" position="right">
            <div class="main-box">
                <div class="personal-data-page">
                    <!-- 顶部导航 -->
                    <div class="title-box">
                        <button class="back" @click="showWithdraw = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2>{{ $t('Transfer2') }}</h2>
                    </div>
                    <div class="infos" style="border-bottom: 1px solid #265145;margin-bottom: 20px;">
                        <div class="lis">
                            <span class="t">{{ $t('Remaining') }}:</span>
                            <span class="t2">{{ $cut2 }} 0.000</span>
                        </div>
                        <div class="lis2">
                            <span class="t">{{ $t('Transfer') }}:</span>
                            <div class="inputs">
                                <input type="text" v-model="value">
                                <a class="cut">{{ $cut2 }}</a>
                            </div>
                            <a class="t3">{{ $t('Usemaximum') }}</a>
                        </div>
                        <div class="lis2">
                            <div class="inputs"
                                style="background: #06241D;line-height: 20px;height: fit-content;padding: 10px 15px;color: #DDCACB;">
                                {{ $t('Note') }}
                            </div>
                        </div>
                        <div class="lis" style="margin-bottom: 10px;">
                            <span class="t">{{ $t('Transferfee') }}:</span>
                            <span class="t3">{{ $t('Free') }}</span>
                        </div>
                        <div class="lis" style="margin-bottom: 10px;">
                            <span class="t">{{ $t('Instant') }}:</span>
                            <span class="t3">{{ $t('Instant') }}</span>
                        </div>
                        <div class="lis" style="margin-bottom: 10px;">
                            <span class="t">{{ $t('Minimumamount') }}:</span>
                            <span class="t3">USDT 0.000</span>
                        </div>
                    </div>
                    <div class="sub-btn" :class="{ 'no-btn': value === '' }">
                        <button class="btn">
                            {{ $t('confirm') }}
                        </button>
                    </div>
                    <div style="height: 50px;"></div>
                </div>
            </div>
        </van-popup>

        <van-popup v-model="showWithdraw2" position="right">
            <div class="main-box">
                <div class="personal-data-page withdraw-box">
                    <!-- 顶部导航 -->
                    <div class="title-box">
                        <button class="back" @click="showWithdraw2 = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2>{{ $t('提款') }}</h2>
                        <button class="btns" @click="tabFun(2)">
                            {{ $t('细节') }}
                        </button>
                    </div>
                    <div class="infos" style="border-bottom: 1px solid #265145;">
                        <div class="lis">
                            <span class="t">{{ $t('提款方式') }}</span>
                            <!-- <span class="t-2" v-if="bankList.length > 0">{{ $t('银行卡') }}</span> -->
                        </div>
                        <div class="lis2" v-if="bankList.length == 0">
                            <div class="inputs"
                                style="background: #222725;line-height: 18px;font-size: 14px;color:#F1EDDE;height: fit-content;padding: 10px 15px;">
                                {{ $t('Note2') }}
                            </div>
                            <a class="qb-btn" @click="$router.push('/account')">{{ $t('前往钱包设置') }}<i
                                    class="iconfont icon-jiantou"></i></a>
                        </div>
                        <div class="lis2" v-if="bankList.length != 0">
                            <div class="inputs" @click="showBank = true"
                                style="background: #222725;line-height: 18px;font-size: 14px;color:#F1EDDE;height: fit-content;padding: 10px 15px;">
                                {{ bank_name != '' ? bank_name : $t('cash.chooseWallet') }}
                            </div>
                        </div>

                    </div>
                    <div class="infos">
                        <div class="lis"
                            style="margin-bottom: 0px;display: flex; flex-direction: column;width: 100%;align-items: flex-start;">
                            <span class="t" style="margin-bottom: 10px;">{{ $t('可提款金额') }}:</span>
                            <span class="t3">{{ $cut2 }} {{ userInfo != null ? userInfo.money : '0.00' }}</span>
                        </div>
                    </div>
                    <div class="infos">
                        <!-- <div class="lis">
                            <span style="font-size: 14px;color: #B3B9BF;">{{ $t('卖') }}</span>
                            <span style="font-size: 14px;color: #B3B9BF;">{{ $t('最低') }} 2{{ $cut2 }}</span>
                        </div> -->
                        <div class="lis3" style="display: flex;">
                            <div class="inputs"
                                style="border: 1px solid #BAC0C6;background: linear-gradient(90deg, rgba(20, 40, 52, 1) 0%, rgba(26, 48, 49, 1) 100%);">
                                <input type="text" v-model="value" placeholder="0.00">
                            </div>
                            <a class="cut">{{ $cut2 }}</a>
                        </div>
                        <div class="lis" style="flex-direction: column;align-items: flex-start;">
                            <span style="margin: 15px 0px 0px 0px;font-size: 10px;color: #FDE68A;">{{
                                $t('cash.arrivalTime') }}</span>
                            <span v-if="userInfo !== null && value > userInfo.money"
                                style="color: #E7B9BB; font-size: 10px;margin-top: 5px;">{{
                                    $t('该金额超过了可提款余额') }}</span>
                        </div>
                        <!-- <div class="lis" style="border: 1px solid #2F4446;display: flex; flex-direction: column;width: 100%;align-items: flex-end;padding:12px 15px;border-radius: 12px;margin-top: 15px;margin-bottom: 0px;background: #0D2228;">
                            <span class="t" style="margin-bottom: 10px;color: #A4ACAE;font-size: 12px;">{{ $t('您将收到') }}</span>
                            <span class="t3" style="font-size: 24px;">{{ $cut2 }} {{ userInfo === null? '0.00':userInfo.money }}</span>
                        </div> -->
                    </div>
                    <div class="sub-btn-box">
                        <div class="sub-btn" style="margin-top: auto;"
                            :class="{ 'no-btn': value === '' || bankList.length === 0 }">
                            <button class="btn" @click="setIniPwd(1)">
                                {{ $t('提款') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>

        <!-- 激励计划 -->
        <van-popup v-model="showJl" position="right">
            <div class="main-box">
                <div class="personal-data-page jl-box" v-if="jl_info != null">
                    <!-- 顶部导航 -->
                    <div class="title-box" style="background: #06241D;">
                        <button class="back" @click="showJl = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2 style="display: flex;flex-direction: column;">
                            <span>{{ $t('jljh') }}</span>
                            <span style="color: #94BAAA;font-size: 10px;margin-top: 5px;">{{ $t('提交视频评测链接') }}</span>
                        </h2>
                        <button class="btns" @click="showJlyjFun">
                            {{ $t('佣金细节') }}
                        </button>
                    </div>
                    <div class="uls-box">

                        <!-- 数据统计区 -->
                        <div class="stats-grid">
                            <div class="stats-item">
                                <div class="stats-label">{{ $t('提交总数') }}</div>
                                <div class="stats-value">{{ jl_info.total_num }}</div>
                            </div>
                            <div class="stats-item">
                                <div class="stats-label">{{ $t('回顾') }}</div>
                                <div class="stats-value">{{ jl_info.pending_num }}</div>
                            </div>
                            <div class="stats-item">
                                <div class="stats-label">{{ $t('得到正式认可的') }}</div>
                                <div class="stats-value">{{ jl_info.approved_num }}</div>
                            </div>
                            <div class="stats-item">
                                <div class="stats-label">{{ $t('已拒绝') }}</div>
                                <div class="stats-value">{{ jl_info.rejected_num }}</div>
                            </div>
                        </div>

                        <!-- 晋升奖励 -->
                        <div class="reward-card">
                            <div class="reward-label">{{ $t('历史总计') }}</div>
                            <div class="reward-amount">{{ $cut2 }} {{ jl_info.historical_money }}</div>
                            <!-- <div class="reward-total">{{ $t('历史总计') }}: {{ jl_info.historical_money }}</div> -->
                            <div class="withdraw-btn" @click="showWithdrawFuns">{{ $t('提款') }} &gt;</div>
                        </div>

                        <!-- 每周表现 -->
                        <div class="weekly-card">
                            <div class="weekly-title">{{ $t('每周表现') }}</div>
                            <div class="weekly-progress">
                                <span class="progress-text">{{ jl_info.weekly_num }}/{{ jl_info.video_week_submit_num }}
                                    {{ $t('已批准') }}</span>
                            </div>
                            <div class="weekly-period">{{ $t('周期') }} {{ mondayDate }} {{ $t('至') }} {{ sundayDate }}。
                            </div>
                            <div class="progress-bar">
                                <div class="progress-inner"
                                    :style="{ width: (jl_info.weekly_num / jl_info.video_week_submit_num) * 100 + '%' }">
                                </div>
                            </div>
                            <div class="weekly-reward">
                                {{ $t('周期奖励') }}：{{ $t('当您获得批准时', { num: jl_info.video_week_submit_num }) }}{{
                                    $t('即可获得') }}
                                +{{ $cut2 }} {{ jl_info.video_submit_amount }}.
                            </div>
                            <!-- <div class="weekly-status">{{ $t('周奖金尚未发放') }}</div> -->
                        </div>

                        <!-- 每日限额 -->
                        <div class="daily-limit">
                            {{ $t('每日限额') }}：{{ $t('今日有效提交次数为') }} {{ jl_info.daily_num }}/{{ jl_info.video_submit_num
                            }} {{
                                $t('次') }},{{ $t('剩余') }}
                            {{ 3 - jl_info.daily_num }} {{ $t('次') }}.
                        </div>

                        <!-- 提交链接区域 -->
                        <div class="submit-section">
                            <div class="submit-title">{{ $t('提交链接以供审核') }}</div>
                            <input type="text" v-model="submitLink" placeholder="https://..." class="submit-input">
                            <button type="primary" block @click="handleSubmit" class="submit-btn">
                                {{ $t('提交审核') }}
                            </button>
                        </div>

                        <!-- 提交历史 -->
                        <div class="history-section">
                            <div class="history-title">{{ $t('提交历史') }}</div>
                            <div class="boxs">
                                <div class="history-tabs">
                                    <span class="tab-item" style="width: 80px;">{{ $t('提交状态') }}</span>
                                    <span class="tab-item" style="width: 130px;">{{ $t('提交日期') }}</span>
                                    <span class="tab-item" style="width: 200px;">{{ $t('提交Url') }}</span>
                                    <span class="tab-item" style="width: 200px;">{{ $t('管理员评论') }}</span>
                                </div>
                                <div class="history-li" style="text-align: center;" v-if="jl_info.list.length === 0">
                                    {{ $t('目前还没有提交任何链接') }}
                                </div>
                                <div class="history-li" v-for="(x, i) in jl_info.list" :key="i">
                                    <span class="tab-item" style="width: 80px;">
                                        <span style="color: #1C9D4D;" v-if="x.status === 1">{{ $t('已通过') }}</span>
                                        <span style="color: #FFD700;" v-if="x.status === 2">{{ $t('审核中') }}</span>
                                        <span style="color: #E82822;" v-if="x.status === 0">{{ $t('已拒绝') }}</span>
                                    </span>
                                    <span class="tab-item" style="width: 130px;">{{ x.submission_date }}</span>
                                    <span class="tab-item" style="width: 200px;">{{ x.submitted_url }}</span>
                                    <span class="tab-item" style="width: 200px;">{{ x.comment ? x.comment : '-'
                                    }}</span>
                                </div>
                            </div>
                        </div>
                        <div style="height: 80px;"></div>
                    </div>
                </div>
            </div>
        </van-popup>
        <!-- 佣金细节 -->
        <van-popup v-model="showYjList" position="right">
            <div class="main-box">
                <div class="personal-data-page jl-box">
                    <!-- 顶部导航 -->
                    <div class="title-box" style="background: #06241D;">
                        <button class="back" @click="showYjList = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2 style="display: flex;flex-direction: column;">
                            <span>{{ $t('佣金细节') }}</span>
                        </h2>
                    </div>
                    <div class="uls-box" v-if="yjList.length === 0">
                        <div
                            style="display: flex;flex-direction: column;padding:60px 20px;justify-content: center;align-items: center;">
                            <span style="color: #96BEAD;font-size:14px;margin-bottom: 10px;">{{ $t('未找到佣金') }}</span>
                            <span style="color: #96BEAD;font-size:14px;">{{ $t('佣金将在您收到款项后显示在此处') }}</span>
                        </div>
                    </div>
                    <div v-else class="uls-box" style="padding: 15px;">
                        <div class="lis" v-for="(item, index) in yjList" :key="index">
                            <div class="t">
                                <span>{{ $t('项目名称') }}</span>
                                <span>{{ $t(item.memo) }}</span>
                            </div>
                            <div class="t">
                                <span>{{ $t('money') }}</span>
                                <span>{{ $cut2 }} {{ $t(item.money) }}</span>
                            </div>
                            <div class="t">
                                <span>{{ $t('time') }}</span>
                                <span>{{ $t(item.time) }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="height: 80px;"></div>
                </div>
            </div>
        </van-popup>
        <!-- 激励计划佣金细节 -->
        <van-popup v-model="showJlyjList" position="right">
            <div class="main-box">
                <div class="personal-data-page jl-box">
                    <!-- 顶部导航 -->
                    <div class="title-box" style="background: #06241D;">
                        <button class="back" @click="showJlyjList = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2 style="display: flex;flex-direction: column;">
                            <span>{{ $t('佣金细节') }}</span>
                        </h2>
                    </div>
                    <div class="uls-box" v-if="jlyjList.length === 0">
                        <div
                            style="display: flex;flex-direction: column;padding:60px 20px;justify-content: center;align-items: center;">
                            <span style="color: #96BEAD;font-size:14px;margin-bottom: 10px;">{{ $t('未找到佣金') }}</span>
                            <span style="color: #96BEAD;font-size:14px;">{{ $t('佣金将在您收到款项后显示在此处') }}</span>
                        </div>
                    </div>
                    <div v-else class="uls-box" style="padding: 15px;">
                        <div class="lis" v-for="(item, index) in jlyjList" :key="index">
                            <div class="t">
                                <span>{{ $t('项目名称') }}</span>
                                <span>{{ $t(item.memo) }}</span>
                            </div>
                            <div class="t">
                                <span>{{ $t('money') }}</span>
                                <span>{{ $t(item.money) }}</span>
                            </div>
                            <div class="t">
                                <span>{{ $t('time') }}</span>
                                <span>{{ $t(item.time) }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="height: 80px;"></div>
                </div>
            </div>
        </van-popup>

        <!-- 提现细节 -->
        <van-popup v-model="showWithdrawList" position="right">
            <div class="main-box">
                <div class="personal-data-page jl-box">
                    <!-- 顶部导航 -->
                    <div class="title-box" style="background: #06241D;">
                        <button class="back" @click="showWithdrawList = false">
                            <i class="iconfont icon-zuojiantou2"></i>
                        </button>
                        <h2 style="display: flex;flex-direction: column;">
                            <span>{{ $t('细节') }}</span>
                        </h2>
                    </div>
                    <div class="tab-boxs">
                        <a :class="{ 'active': tabIndex === index }" v-for="(item, index) in tabList" :key="index"
                            @click="tabFun(index)">
                            {{ $t(item) }}
                        </a>
                    </div>
                    <div class="uls-box" v-if="list2.length === 0" style="padding: 15px;">
                        <div
                            style="background:#193631;display: flex;flex-direction: column;padding:30px 20px;justify-content: center;align-items: center;border: 1px solid #294540;border-radius: 12px;">
                            <span style="color: #93A19E;font-size:14px;">{{ $t('未找到交易记录') }}</span>
                        </div>
                    </div>
                    <div v-else class="uls-box" style="padding: 15px;">
                        <div class="lis" v-for="(item, index) in list2" :key="index">
                            <div class="t" v-if="tabIndex === 0">
                                <span>{{ $t('兑换码') }}</span>
                                <span>{{ $t(item.code) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 0">
                                <span>{{ $t('奖励金额') }}</span>
                                <span>{{ $t(item.reward_amount) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 0">
                                <span>{{ $t('兑换时间') }}</span>
                                <span>{{ $t(item.create_time) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                                <span>{{ $t('金额') }}</span>
                                <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                                <span>{{ $t('订单编号') }}</span>
                                <span>{{ $t(item.orderid) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 1 || tabIndex === 2">
                                <span>{{ $t('状态') }}</span>
                                <span style="color: #CBCB41;" v-if="item.status === 3">{{ $t('PendingReview') }}</span>
                                <span style="color: #25C582;" v-if="item.status === 1">{{ $t('Completed') }}</span>
                                <span style="color: #D71804;" v-if="item.status === 2">{{ $t('Rejected') }}</span>
                                <!-- <span style="color: #CBCB41;" v-if="item.status === 3">{{ $t('PendingSubmission') }}</span> -->
                            </div>
                            <div class="t" v-if="tabIndex === 3">
                                <span>{{ $t('投资金额 ') }}</span>
                                <span style="color: #FDE68A;font-weight: bold;">{{ $cut2 }} {{ $t(item.money) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 3">
                                <span>{{ $t('预计收益 ') }}</span>
                                <span>{{ item.rate }}%</span>
                            </div>
                            <div class="t" v-if="tabIndex === 3">
                                <span>{{ $t('结算状态 ') }}</span>
                                <span style="color: #CBCB41;" v-if="item.status === 0">{{ $t('orders.unfinish')
                                    }}</span>
                                <span style="color: #25C582;" v-if="item.status === 1">{{ $t('orders.finish') }}</span>
                            </div>

                            <div class="t" v-if="tabIndex !== 3">
                                <span>{{ $t('订单创建时间') }}</span>
                                <span>{{ $t(item.time) }}</span>
                            </div>
                            <div class="t"
                                v-if="tabIndex === 2 && item.status === 2 && item.remark != null || tabIndex === 1 && item.status === 2 && item.remark != null">
                                <span>{{ $t('拒绝原因') }}</span>
                                <span style="color: #D71804;">{{ $t(item.remark) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 2 && item.status === 1 && item.type == 999 || tabIndex === 1 && item.status === 1 && item.type == 999">
                                <span>{{ $t('备注') }}</span>
                                <span style="color: #D71804;">{{ $t(item.remark) }}</span>
                            </div>
                            <div class="t" v-if="tabIndex === 3">
                                <span>{{ $t('投资时长 ') }}</span>
                                <span>{{ $t(item.day_text) }}</span>
                            </div>
                        </div>
                    </div>
                    <div style="height: 80px;"></div>
                </div>
            </div>
        </van-popup>
        <!-- 顶部导航栏 -->
        <header class="top-nav">
            <button class="back-btn" @click="goBack">
                <i class="iconfont icon-zuojiantou"></i>
                <span>{{ $t('ReferralSystem') }}</span>
            </button>
            <button class="rules-btn" @click="showLevel = true">{{ $t('Rules') }}</button>
        </header>

        <!-- 推广者激励横幅 -->
        <section class="promo-banner">
            <h2 class="banner-title">{{ $t('msg1') }}</h2>
            <p class="banner-desc">{{ $t('msg2') }}</p>
            <button class="learn-more-btn" @click="showJlFun">{{ $t('Learnmore') }}</button>
        </section>

        <!-- 等级佣金卡片 -->
        <section class="level-card" v-if="userInfo != null">
            <div class="level-badge">
                <div class="badge-icon" :class="'logo-' + userInfo.level.level">
                    <span class="badge-text">Lv.{{ userInfo !== null ? userInfo.level.level == 10 ? 'SVIP' : userInfo.level.level : 0 }}</span>
                </div>
            </div>
            <div class="commission-levels">
                <div class="level-item">
                    <span class="level-rate">{{ userInfo !== null ? Math.floor(userInfo.level.one_commission) : 0
                        }}%</span>
                    <span class="level-name">{{ $t('Level') }} 1</span>
                    <span class="level-reinvest">{{ $t('Reinvest') }} {{ userInfo !== null ?
                        userInfo.level.one_commission / 2 : 0 }}%</span>
                </div>
                <div class="level-item">
                    <span class="level-rate">{{ userInfo !== null ? Math.floor(userInfo.level.two_commission) : 0
                        }}%</span>
                    <span class="level-name">{{ $t('Level') }} 2</span>
                    <span class="level-reinvest">{{ $t('Reinvest') }} {{ userInfo !== null ?
                        userInfo.level.two_commission / 2 : 0 }}%</span>
                </div>
                <div class="level-item">
                    <span class="level-rate">{{ userInfo !== null ?
                        Math.floor(userInfo.level.three_commission) : 0 }}%</span>
                    <span class="level-name">{{ $t('Level') }} 3</span>
                    <span class="level-reinvest">{{ $t('Reinvest') }} {{ userInfo.level.three_commission / 2 }}%</span>
                </div>
            </div>
        </section>

        <!-- 数据统计卡片 -->
        <section class="stats-grid" v-if="info != null">
            <div class="stat-card">
                <span class="stat-label">{{ $t('CommissionValue') }} ({{ $cut2 }})</span>
                <h3 class="stat-value">{{ info.today_invite_commission || 0 }}</h3>
                <a @click="showWithdrawFuns" class="stat-link">{{ $t('index.withdraw') }} ></a>
            </div>
            <div class="stat-card">
                <span class="stat-label">{{ $t('TotalCommission') }} ({{ $cut2 }})</span>
                <h3 class="stat-value">{{ info.invite_commission || 0 }}</h3>
                <a @click.stop="showYjListFun" class="stat-link">{{ $t('Details') }}</a>
            </div>
            <div class="stat-card">
                <span class="stat-label">{{ $t('NumberInvites') }} <a class="tooltip" @click="tis1Staus = !tis1Staus">?
                        <span class="tis" v-if="tis1Staus">{{ $t('tis1') }}</span></a></span>
                <h3 class="stat-value">{{ info.invite_num || 0 }}</h3>
            </div>
            <div class="stat-card">
                <span class="stat-label">{{ $t('Totalinvestment') }} ({{ $cut2 }}) <a class="tooltip"
                        @click="tis2Staus = !tis2Staus">?<span class="tis" v-if="tis2Staus">{{ $t('tis2')
                        }}</span></a></span>
                <h3 class="stat-value">{{ info.invite_investment_amount || 0 }}</h3>
            </div>
        </section>

        <section class="stats-grid" v-if="info != null">
            <div class="stat-card" style="width: 100%;position: relative;">
                <span class="tis2" v-if="tis3Staus">{{ $t('tis3') }}</span>
                <span class="stat-label">{{ $t('存款总额') }} ({{ $cut2 }}) <a class="tooltip"
                        @click="tis3Staus = !tis3Staus">?</a></span>
                <h3 class="stat-value">{{ info.invite_deposit_amount || 0 }}</h3>
            </div>
        </section>

        <!-- 分享按钮组 -->
        <section class="share-actions">
            <button class="btn btn-copy" @click="copyLink">
                <span class="iconfont icon-fuzhi-"></span>
                <b>
                    {{ $t('Copylink') }}
                </b>
            </button>
            <!-- <button class="btn btn-more">
                <i class="iconfont icon-fenxiang"></i>
                <b>{{ $t('Moreways') }}</b>
            </button> -->
        </section>

        <!-- 数据表格区域 -->
        <section class="data-table-section" v-if="commission != null">
            <div class="table-tabs">
                <div class="tab-boxs">
                    <button class="tab-btn" :class="{ 'active': tabIndex === 0 }" style="margin-right: 8px;"
                        @click="tabChange(0)">{{ $t('jr') }}</button>
                    <button class="tab-btn" :class="{ 'active': tabIndex === 1 }" @click="tabChange(1)">{{ $t('Total')
                    }}</button>
                </div>
                <a @click="showDetail" class="table-details">{{ $t('Details') }} ></a>
            </div>
            <ul class="data-table" v-if="tabIndex === 0">
                <li>
                    <div> {{ $t('Data') }} </div>
                    <div> {{ $t('Level') }} 1</div>
                    <div> {{ $t('Level') }} 2</div>
                    <div> {{ $t('Level') }} 3</div>
                </li>
                <li>
                    <div>{{ $t('Commission') }}</div>
                    <div>{{ commission.today.total_one_commission || '0.00' }}</div>
                    <div>{{ commission.today.total_two_commission || '0.00' }}</div>
                    <div>{{ commission.today.total_three_commission || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('NumberInvestors') }}</div>
                    <div>{{ commission.today.total_one_number_investors || '0.00' }}</div>
                    <div>{{ commission.today.total_two_number_investors || '0.00' }}</div>
                    <div>{{ commission.today.total_three_number_investors || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('Numberdepositors') }}</div>
                    <div>{{ commission.today.total_one_deposit_number || '0.00' }}</div>
                    <div>{{ commission.today.total_two_deposit_number || '0.00' }}</div>
                    <div>{{ commission.today.total_three_deposit_number || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('Registered') }}</div>
                    <div>{{ commission.today.total_one_register_number || '0.00' }}</div>
                    <div>{{ commission.today.total_two_register_number || '0.00' }}</div>
                    <div>{{ commission.today.total_three_register_number || '0.00' }}</div>
                </li>
            </ul>
            <ul class="data-table" v-if="tabIndex === 1">
                <li>
                    <div>{{ $t('Data') }}</div>
                    <div>{{ $t('Level') }} 1</div>
                    <div>{{ $t('Level') }} 2</div>
                    <div>{{ $t('Level') }} 3</div>
                </li>
                <li>
                    <div>{{ $t('Commission') }}</div>
                    <div>{{ commission.list.total_one_commission || '0.00' }}</div>
                    <div>{{ commission.list.total_two_commission || '0.00' }}</div>
                    <div>{{ commission.list.total_three_commission || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('NumberInvestors') }}</div>
                    <div>{{ commission.list.total_one_number_investors || '0.00' }}</div>
                    <div>{{ commission.list.total_two_number_investors || '0.00' }}</div>
                    <div>{{ commission.list.total_three_number_investors || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('Numberdepositors') }}</div>
                    <div>{{ commission.list.total_one_deposit_number || '0.00' }}</div>
                    <div>{{ commission.list.total_two_deposit_number || '0.00' }}</div>
                    <div>{{ commission.list.total_three_deposit_number || '0.00' }}</div>
                </li>
                <li>
                    <div>{{ $t('Registered') }}</div>
                    <div>{{ commission.list.total_one_register_number || '0.00' }}</div>
                    <div>{{ commission.list.total_two_register_number || '0.00' }}</div>
                    <div>{{ commission.list.total_three_register_number || '0.00' }}</div>
                </li>
            </ul>
        </section>

        <!-- 系统说明区域 -->
        <section class="info-section">
            <div class="info-header" @click.stop="showFun">
                <h3>{{ $t('system1') }}</h3>
                <button class="collapse-btn" :class="{ 'xz': showText }">
                    <i class="iconfont icon-xiajiantou"></i>
                </button>
            </div>
            <div class="info-content" v-if="showText">
                <div class="info-block">
                    <h4>{{ $t('system2') }}</h4>
                    <ul>
                        <li>-{{ $t('Level') }} 1: {{ userInfo !== null ? Math.floor(userInfo.level.one_commission) : 0
                            }}%
                            {{ $t('Commission') }}</li>
                        <li>-{{ $t('Level') }} 2: {{ userInfo !== null ? Math.floor(userInfo.level.two_commission) : 0
                            }}%
                            {{ $t('Commission') }}</li>
                        <li>-{{ $t('Level') }} 3: {{ userInfo !== null ? Math.floor(userInfo.level.three_commission) :
                            0 }}% {{ $t('Commission') }}</li>
                    </ul>
                </div>
                <div class="info-block">
                    <h4>{{ $t('Reinvestments') }}:</h4>
                    <p>{{ $t('system3', { num: 50 }) }}</p>
                    <ul>
                        <li>-{{ $t('Level') }} 1: {{ userInfo !== null ? userInfo.level.one_commission / 2 : 0 }}%</li>
                        <li>-{{ $t('Level') }} 2: {{ userInfo !== null ? userInfo.level.two_commission / 2 : 0 }}%</li>
                        <li>-{{ $t('Level') }} 3: {{ userInfo !== null ? userInfo.level.three_commission / 2 : 0 }}%
                        </li>
                    </ul>
                </div>
                <div class="info-block">
                    <h4>{{ $t('system4') }}:</h4>
                    <ul>
                        <li>-{{ $t('schema5') }}</li>
                        <li>-{{ $t('schema6') }}</li>
                        <li>-{{ $t('schema7') }}</li>
                        <li>-{{ $t('schema8') }}</li>
                    </ul>
                </div>
                <div class="info-block">
                    <h4>{{ $t('schema9') }}:</h4>
                    <ul>
                        <li>-{{ $t('schema10') }}</li>
                        <li>-{{ $t('schema11') }}</li>
                        <li>-{{ $t('schema12') }}</li>
                    </ul>
                </div>
            </div>
        </section>
        <div style="height: 150px;"></div>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from "../../utils/fetch";
import {
    PasswordInput,
    NumberKeyboard,
    ActionSheet,
    Toast,
    Dialog 
} from 'vant';
let timeOut = null;
Vue.use(PasswordInput).use(NumberKeyboard).use(ActionSheet).use(Dialog)
export default {
    name: 'ReferralSystem',
    created() {
        this.$parent.footer('equipe');
        this.getCommission()
        this.getLevelList()
        this.getCommissionDetails()
        Fetch("/user/info").then((r) => {
            this.userInfo = r.data;
        });
        this.initWeekDate()
    },
    mounted() {
        timeOut = setInterval(() => {
            Fetch("/user/info", {}, {}, false).then((r) => {
                this.$set(this, 'userInfo', r.data)
            });
            Fetch('/user/commission_details', {}, {}, false).then((r) => {
                this.$set(this, 'info', r.data)
                this.list = r.data.list
            });
        }, 15000)
    },
    beforeDestroy() {
        // 先判断定时器是否存在，避免报错
        if (timeOut) {
            clearInterval(timeOut);
            timeOut = null; // 清空引用，防止内存泄漏
        }
    },
    data() {
        return {
            mondayDate: '', // 存储本周周一日期（格式化后）
            sundayDate: '',  // 存储本周周日日期（格式化后）
            showText: false,
            showWithdraw: false,    //显示提款
            showWithdraw2: false,     //显示提款
            commission: null,
            tabIndex: 0,
            show: false,
            list: [],
            levelList: [],
            info: null,
            value: '',
            userInfo: null,
            showLevel: false,
            showJl: false,
            jl_info: null,
            showJlyjList: false,
            jlyjList: [],
            showYjList: false,
            yjList: [],
            // 提交链接
            submitLink: '',
            showWithdrawList: false, //显示提现细节
            list2: [],
            tabIndex: 0,
            tabList: ['投资', '充值', '提现', '兑换码'],
            bankList: [],
            setPwd: false,
            submitType: 1,
            write_psd: false,
            showKeyboard: true,
            psd_val: '',
            zf_passwrod: '',
            showBank: false,
            chargeTip: '',
            bank_id: '',
            charge: '',
            type: '',
            rate: '',
            mark: '',
            user_name: '',
            bank_name: '',
            actions: [],
            maxMoney: '',
            tis1Staus: 0,
            tis2Staus: 0,
            tis3Staus: 0,
        }
    },
    methods: {
        formatNumber(num) {
            // 先转为字符串，处理空值/非数字情况
            const str = String(num || '');
            // 长度不足9位时返回原字符串（避免格式错误）
            if (str.length < 9) return str;
            // 截取前3位 + 6个* + 后3位
            return str.slice(0, 3) + '******' + str.slice(-3);
        },
        onSelect(item) {
            this.value = "";
            this.showBank = false;
            this.bank_name = item.name;
            this.user_name = item.user || ''
            this.bank_id = item.value;
            this.charge = item.charge;
            this.type = item.type;
            this.rate = item.rate;
            this.mark = item.mark;
            if (item.charge > 0) {
                this.chargeTip = this.$t('cash.charge') + item.charge + "%";
            } else {
                this.chargeTip = "";
            }
            this.submitType = 1;
            if (item.value == 0) {
                this.$router.push('/addcountUsdt')
            }
        },
        onInput(key) {
            this.psd_val = (this.psd_val + key).slice(0, 6);
            if (this.psd_val.length == 6) {
                this.write_psd = false;
                this.zf_passwrod = this.psd_val;
                console.log(this.submitType, 'submitType')
                if (this.submitType == 1) {
                    this.submit();
                } else {
                    this.setIniPwdSubmit();
                }

            }
        },
        submit() {
            this.psd_val = "";
            if (!this.zf_passwrod) {
                this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
                return false;
            }
            Fetch('/user/cost_apply', {
                money: this.value,
                bank_id: this.bank_id,
                passwd: this.zf_passwrod
            }).then((r) => {
                if (r.code == 1) {
                    Toast(r.info)
                    setTimeout(() => {
                        this.showWithdraw2 = false
                    }, 500);
                } else {
                    Toast(r.msg)
                }
            });
        },
        setIniPwdSubmit() {
            this.psd_val = "";
            let data = {
                password: this.zf_passwrod
            }
            Fetch('/user/setIniPwd', data).then((r) => {
                if (r.code == 1) {
                    Toast(r.info)
                    this.zf_passwrod = ''
                    setTimeout(() => {
                        this.setPwd = false;
                    }, 500);
                } else {
                    Toast(r.msg)
                }
            });
        },
        onDelete() {
            this.psd_val = this.psd_val.slice(0, this.psd_val.length - 1);
        },
        setIniPwd(type) {
            if (type === 1) {
                if (this.bankList.length === 0) {
                    return
                }
                if (this.bank_id == 0 || this.bank_id == -1) {
                    // this.$toast(this.$t('cash.withdrawalAccountEmpty'));
                    return false;
                }
                if (!this.value) {
                    this.$toast(this.$t('cash.withdrawalAmountEmpty'));
                    return false;
                }
                if (this.value < 0) {
                    this.$toast(this.$t('cash.withdrawalAmountNotAllow'));
                    return false;
                }
                if (parseInt(this.value) > parseInt(this.money)) {
                    this.$toast(this.$t('cash.withdrawalAmountHigh'));
                    return false;
                }
                this.write_psd = true;
                return
            }
            this.submitType = 2;
            this.setPwd = false;
            this.write_psd = true;
        },
        showWithdrawFun() {
            this.showWithdrawList = true
        },
        showWithdrawFuns() {
            Fetch('/user/my_bank').then((r) => {
                if (r.code == 1) {
                    // console.log(r, 'rrr')
                    this.money = r.data.money
                    this.bankList = r.data.bank
                    this.setPwd = r.data.intPwd;
                    var bankvalue = []
                    r.data.bank.forEach(item => {
                        var length = item.user.length;
                        var account = item.user + "";
                        var itemAccount = account.substr(length - 4, length)
                        bankvalue.push({
                            name: item.bank + "(****" + itemAccount + ")",
                            value: item.id,
                            charge: item.charge,
                            rate: item.rate,
                            type: item.type,
                            mark: item.mark,
                            user: item.user
                        })
                    })
                    bankvalue.push({
                        name: this.$t('cash.addWallet'),
                        value: 0,
                        color: "#FF0000",
                    })
                    this.actions = bankvalue;
                    if (!this.setPwd) {
                        if (this.bankList.length > 0) {
                            this.showWithdraw2 = true
                        } else {
                            Dialog.confirm({
                                message: this.$t('暂无提款方式'),
                                confirmButtonText: this.$t('utils.confirm'),
                                cancelButtonText: this.$t('utils.cancel')
                            }).then(() => {
                                this.$router.push("/account");
                            }).catch(() => {
                                // on cancel
                            });
                        }
                    }
                } else {
                    this.bankList = []
                    this.$toast(r.msg)
                }
            });
        },
        /**
         * 格式化日期为 YYYY-MM-DD 格式
         * @param {Date} date - 原始日期对象
         * @returns {String} 格式化后的日期字符串
         */
        formatDate(date) {
            const year = date.getFullYear()
            // 月份从 0 开始，需 +1；padStart 补零保证两位数
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            return `${year}-${month}-${day}`
        },

        /**
         * 计算本周周一和周日的原始日期对象
         * @returns {Object} 包含 monday 和 sunday 的 Date 对象
         */
        getWeekRange() {
            const now = new Date()
            const day = now.getDay() // 获取当前星期数（0=周日，1=周一...6=周六）

            // 计算本周周一
            const monday = new Date(now)
            // 核心逻辑：周日（day=0）则减6天，其他日期减 (day-1) 天
            monday.setDate(now.getDate() - (day === 0 ? 6 : day - 1))

            // 计算本周周日
            const sunday = new Date(now)
            // 核心逻辑：周日（day=0）则加0天，其他日期加 (6 - day) 天
            sunday.setDate(now.getDate() + (6 - (day === 0 ? 7 : day)))

            return { monday, sunday }
        },

        /**
         * 初始化本周日期（主入口）
         */
        initWeekDate() {
            const { monday, sunday } = this.getWeekRange()
            this.mondayDate = this.formatDate(monday)
            this.sundayDate = this.formatDate(sunday)
        },
        handleWithdraw() {
            // 提款逻辑
        },
        handleSubmit() {
            // 提交审核逻辑
            Fetch('/user_submissions/submit', {
                'video_url': this.submitLink
            }).then((r) => {
                if (r.code == 1) {
                    this.$toast(r.info)
                    setTimeout(() => {
                        Fetch('/user_submissions/info').then((r) => {
                            this.$set(this, 'jl_info', r.data)
                        });
                    }, 2000)
                } else {
                    this.$toast(r.msg)
                }
            });
        },
        goBack() {
            this.$router.go(-1)
        },
        copyLink() {
            try {
                console.log(window.location)
                const currentDomain = window.location.protocol + '//' + window.location.host + '#/register?invite_code=' + this.userInfo.invite_code;
                // 创建临时输入框实现复制
                const input = document.createElement('input');
                input.value = currentDomain;
                document.body.appendChild(input);
                input.select();
                document.execCommand('copy');
                document.body.removeChild(input);
                // 提示复制成功（可替换为你的全局提示组件）
                this.$toast(this.$t('复制成功'))
            } catch (err) {
                this.$toast(this.$t('复制失败'))
                console.error('复制失败：', err);
            }
        },
        showFun() {
            this.showText = !this.showText
        },
        getCommission() {
            Fetch('/user/commission').then((r) => {
                this.commission = r.data
                console.log(this.commission, 'commissionList')
            });
        },
        getLevelList() {
            Fetch('/user/level').then((r) => {
                // console.log(r,'rrr')
                this.levelList = r.data.list
                // console.log(this.list,'list')
            });
        },
        tabChange(type) {
            this.tabIndex = type
        },
        showDetail() {
            this.show = true
        },
        getCommissionDetails() {
            Fetch('/user/commission_details').then((r) => {
                this.info = r.data
                this.list = r.data.list
            });
        },
        showJlFun() {
            Fetch('/user_submissions/info').then((r) => {
                this.jl_info = r.data
                this.showJl = true
            });
        },
        showJlyjFun() {
            Fetch('/user_submissions/commission_list').then((r) => {
                this.jlyjList = r.data.list
                this.showJlyjList = true
            });
        },
        showYjListFun() {
            Fetch('/user/commission_list').then((r) => {
                this.yjList = r.data.list
                this.showYjList = true

            });
        },
        tabFun(index) {
            this.tabIndex = index
            if (index === 3) {
                Fetch('/redeem/info').then((r) => {
                    if (r.code == 1) {
                        // console.log(r.data, 'rrr')
                        this.list2 = r.data.list
                    } else {
                        this.$toast(r.msg)
                    }
                });
            }
            if (index === 2) {
                Fetch('/user/cash_list').then((r) => {
                    if (r.code == 1) {
                        // console.log(r.data, 'rrr')
                        this.list2 = r.data
                    } else {
                        this.$toast(r.msg)
                    }
                });
            }
            if (index === 1) {
                Fetch('/user/recharge_list').then((r) => {
                    if (r.code == 1) {
                        // console.log(r.data, 'rrr')
                        this.list2 = r.data
                    } else {
                        this.$toast(r.msg)
                    }
                });
            }
            if (index === 0) {
                Fetch('/user/order').then((r) => {
                    if (r.code == 1) {
                        // console.log(r.data, 'rrr')
                        this.list2 = r.data.list
                    } else {
                        this.$toast(r.msg)
                    }
                });
            }
            this.showWithdrawFun()
        }
    }
}
</script>

<style scoped lang="less">
/* 全局容器 */
.referral-container {
    width: 100%;
    margin: 0 auto;
    background-color: #1a2435;
    height: 100vh;
    color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    padding-bottom: 20px;
}

/* 顶部导航 */
.top-nav {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #324354;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    background: linear-gradient(96deg, #16324a, #11283d 58%, #0b1d30);
}

.back-btn,
.rules-btn {
    background-color: #2a3b55;
    border: none;
    color: #ffffff;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 16px;
    border: 1px solid #3D5266;
    cursor: pointer;
}

.rules-btn {
    background: #0C1F33;
}

.page-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
}

/* 推广横幅 */
.promo-banner {
    margin: 15px;
    padding: 20px;
    background: linear-gradient(90deg, #f7d060, #2ccf70);
    border-radius: 12px;
    color: #1a2435;
}

.banner-title {
    font-size: 22px;
    font-weight: 600;
    margin: 0 0 8px 0;
}

.banner-desc {
    font-size: 14px;
    margin: 0 0 16px 0;
    opacity: 0.8;
}

.learn-more-btn {
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    color: #1a2435;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 14px;
    cursor: pointer;
}

/* 等级佣金卡片 */
.level-card {
    display: flex;
    align-items: center;
    margin: 0 16px 16px;
    padding: 25px 20px;
    background: linear-gradient(112deg, #1a4b6b, #163f5c 46%, #112c45);
    border-radius: 16px;
    border: 1px solid #375F7A;
}

.level-badge {
    margin-right: 20px;
}

.badge-icon {
    width: 40px;
    height: 60px;
    background-size: cover;
    background-position: center center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 18px;
}

.badge-text {
    font-size: 16px;
    font-weight: bold;
    color: #2d2d2d;
}

.commission-levels {
    display: flex;
    flex: 1;
    justify-content: space-between;
}

.level-item {
    text-align: center;
}

.level-rate {
    display: block;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
}

.level-name {
    display: block;
    font-size: 12px;
    opacity: 0.8;
    margin-bottom: 6px;
}

.level-reinvest {
    display: block;
    font-size: 12px;
    opacity: 0.6;
}

/* 统计卡片网格 */
.stats-grid {
    display: flex;
    justify-content: space-between;
    margin: 0 16px 0px;
    flex-wrap: wrap;
}

.stat-card {
    width: 48.5%;
    background: radial-gradient(circle at 86% 4%, rgba(251, 191, 36, .14), transparent 44%), radial-gradient(circle at 8% 94%, rgba(52, 211, 153, .12), transparent 46%);
    padding: 15px;
    border-radius: 12px;
    margin-bottom: 10px;
    border: 1px solid #344351;
    display: flex;
    flex-direction: column;
}

.stat-card.full-width {
    grid-column: 1 / -1;
}

.stat-label {
    font-size: 10px;
    opacity: 0.7;
    display: block;
    margin-bottom: 12px;
}

.tooltip {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    margin-left: 4px;
    position: relative;

    .tis {
        position: absolute;
        left: 50%;
        transform: translate(-50%, -105%);
        z-index: 99;
        top: 0px;
        width: 150px;
        z-index: 1;
        padding: 5px;
        border-radius: 8px;
        border: 1px solid #344351;
        background: rgba(0, 0, 0, 0.8);
    }

}

.tis2 {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
    top: -24px;
    width: 300px;
    background: rgba(0, 0, 0, 0.8);
    z-index: 1;
    padding: 5px;
    text-align: center;
    color: #BFC0B8;
    border-radius: 8px;
    border: 1px solid #344351;
}

.stat-value {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.stat-link {
    font-size: 12px;
    color: #f7d060;
    text-decoration: none;
    margin-top: 5px;
    cursor: pointer;
}

/* 分享按钮组 */
.share-actions {
    display: flex;
    gap: 12px;
    margin: 5px 16px 16px;
}

.btn {
    flex: 1;
    padding: 12px 0;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

.btn-copy {
    background-color: #25C581;
    color: #1a2435;
}

.btn-more {
    background-color: #1B262F;
    color: #ffffff;
    border: 1px solid #3C464F;
}

.btn-icon {
    font-size: 16px;
}

/* 数据表格区域 */
.data-table-section {
    margin: 0 16px 16px;
    background: radial-gradient(circle at 86% 4%, rgba(251, 191, 36, .14), transparent 44%), radial-gradient(circle at 8% 94%, rgba(52, 211, 153, .12), transparent 46%);
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #3D484F;
}

.table-tabs {
    display: flex;
    align-items: center;
    padding: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.tab-boxs {
    padding: 5px;
    border: 1px solid #374E4D;
    background: #14302D;
    border-radius: 10px;
}

.tab-btn {
    background-color: transparent;
    border: none;
    color: #ffffff;
    padding: 10px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
}

.tab-btn.active {
    background-color: #336F5E;
    color: #fff;
    border: 1px solid #5CC39C;
    box-shadow: 0px 0px 8px #5CC39C;
}

.table-details {
    margin-left: auto;
    font-size: 14px;
    color: #f7d060;
    text-decoration: none;
    cursor: pointer;
}

.data-table {
    width: 100%;
    border-collapse: collapse;
}

.data-table li {
    width: 100%;
    display: flex;
    padding: 0px 20px;
    align-items: center;
    border-bottom: 1px solid #3A4244;
}

.data-table div {
    flex: 1;
    padding: 10px;
    text-align: center;
    font-size: 12px;
}

.data-table div:nth-child(1) {
    text-align: left;
}

.data-table th {
    opacity: 0.7;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.data-table div {
    opacity: 0.8;
}

/* 系统说明区域 */
.info-section {
    margin: 0 16px;
    background-color: #232C2F;
    border-radius: 12px;
    overflow: hidden;
    border: 1px solid #3E484F;
}

.info-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    cursor: pointer;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-header h3 {
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}

.collapse-btn {
    background: none;
    border: none;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    transform: 0.2s;
}

.info-content {
    padding: 12px;
    background: #232C2F;
}

.info-block {
    margin-bottom: 20px;
}

.info-block:last-child {
    margin-bottom: 0;
}

.info-block h4 {
    font-size: 14px;
    font-weight: 600;
    margin: 0 0 12px 0;
}

.info-block p {
    font-size: 12px;
    opacity: 0.8;
    margin: 0 0 12px 0;
}

.info-block ul {
    margin: 0;
    padding-left: 10px;
}

.info-block li {
    font-size: 12px;
    opacity: 0.8;
    margin-bottom: 8px;
}

.xz {
    transform: rotate(180deg);
}

.main-box {
    width: 100vw;
    max-width: 520px;
    height: 100dvh;
    position: relative;
    background-image: linear-gradient(90deg, #0d3a32, #082820 55%, #051a15);

    /* 页面容器 */
    .personal-data-page {
        width: 100%;
        height: 100dvh;
        overflow: hidden;
        overflow-y: scroll;
        // padding: 15px;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        position: relative;
        background: linear-gradient(180deg, #07161cf2, #051018eb 45%, #051614e6);
        background-image: radial-gradient(circle at 82% 12%, rgba(52, 211, 153, .11), transparent 45%), radial-gradient(circle at 15% 96%, rgba(251, 191, 36, .1), transparent 40%);
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 30;

        .sub-btn {
            width: 92%;
            height: 48px;
            background: #25C582;
            color: #222222;
            font-size: 14px;
            border-radius: 10px;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .no-btn {
            background: #15915d;
        }

        /* 顶部导航栏 */
        .title-box {
            width: 100%;
            display: flex;
            align-items: center;
            padding: 15px;
            height: 60px;
            position: sticky;
            top: 0px;
            z-index: 10;
            background: #072B22;
            border-bottom: 1px solid #265245;

            h2 {
                color: #E6F7EF;
                margin-left: 10px;
            }

            .btn,
            .back {
                height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: 1px solid #375852;
                border-radius: 12px;
                padding: 8px 9px;
                color: #fff;
                margin-left: auto;
                background: none;

                .iconfont {
                    font-size: 18px;
                }
            }

            .back {
                margin-left: 0px;
            }
        }

        .infos {
            padding: 15px;
            width: 100%;

            .lis,
            .lis2 {
                width: 100%;
                margin-bottom: 25px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .t,
                .t2,
                .t3 {
                    font-size: 14px;
                }

                .t {
                    color: #A9D3C0;
                }

                .t2 {
                    font-weight: bold;
                }

                .t3 {
                    color: #E6F7EF;
                }
            }

            .lis2 {
                flex-direction: column;
                align-items: flex-start;

                .t {
                    margin-bottom: 10px;
                }

                .t3 {
                    margin-top: 10px;
                    font-size: 14px;
                    color: #9de6c6;
                }

                .inputs {
                    width: 100%;
                    height: 50px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 5px 15px;
                    border: 1px solid #365753;
                    background: #133932;

                    input {
                        width: 80%;
                        height: 100%;
                        font-size: 16px;
                        color: #FFFFFF;
                    }

                    .cut {
                        width: fit-content;
                        height: 32px;
                        padding: 0px 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: #042018;
                        border-radius: 8px;
                        font-size: 14px;
                        font-weight: bold;
                        background: #28C689;
                        border: 1px solid #62DDAC;
                    }
                }
            }
        }

    }

    .withdraw-box {
        background: linear-gradient(180deg, #102131, #0d1a2a);

        .btns {
            margin-left: auto;
            font-size: 12px;
            color: #C5C9CD;
            border: 1px solid #3A4957;
            background: #172839;
            padding: 6px 8px;
            border-radius: 12px;
        }

        .infos {
            width: 92%;
            height: fit-content;
            margin-top: 10px;
            margin-bottom: 0px;
            border-radius: 12px;
            background: #0c2030;
            border: 1px solid #3A4957;

            .lis,
            .lis2 {
                margin-bottom: 10px;

                .t {
                    color: #ffffff;
                }

                .t3 {
                    font-size: 20px;
                    color: #fff;
                }
            }

            .lis2 {
                margin-bottom: 0px;
            }

            .lis3 {
                flex-direction: row;
                margin-bottom: 0px;
                justify-content: space-between;

                .inputs {
                    width: 85%;
                    height: 42px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 5px 15px;
                    border: 1px solid #365753;
                    background: #133932;

                    input {
                        width: 80%;
                        height: 100%;
                        font-size: 16px;
                        color: #FFFFFF;
                    }

                }

                .cut {
                    width: fit-content;
                    height: 42px;
                    margin-left: 10px;
                    padding: 0px 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: bold;
                    background: #152A32;
                    border: 1px solid #D4D7DB;
                }
            }

        }

        .sub-btn-box {
            width: 100%;
            padding: 10px 0px 20px 0px;
            border-top: 1px solid #1F2E3B;
            display: flex;
            justify-content: center;
            height: fit-content;
            margin-top: auto;
        }
    }

    .withdraw-box .title-box {
        background: linear-gradient(98deg, #133329, #0f2635 48%, #0b1b2c);
    }
}

.list-info-box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 15px;

    .boxs {
        width: 32%;
        height: 85px;
        background: #143C35;
        border-radius: 10px;
        border: 1px solid #265345;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 15px;

        .t {
            font-size: 18px;
            font-weight: bold;
        }

        .t2 {
            font-size: 12px;
            color: #91B9A8;
            text-align: center;
            margin-top: 10px;
        }
    }
}

.list-box {
    width: calc(100% - 30px);
    border: 1px solid #265345;
    border-radius: 15px;
    background: #10332D;
    overflow: hidden;

    .t {
        width: 100%;
        height: 42px;
        display: flex;
        align-items: center;
        padding: 15px;
        font-size: 14px;
        font-weight: bold;
        color: #D4E8E0;
        border-bottom: 1px solid #265345;
    }

    .uls {
        width: 100%;
        height: fit-content;

        .title {
            border-bottom: 1px solid #265345;
            padding: 12px 15px;
            display: flex;

            .h {
                flex: 1;
                text-align: center;
                color: #85AB9D;
                white-space: nowrap;
            }

            .h:nth-child(1) {
                text-align: left;
            }
        }

        .lis {
            display: flex;
            padding: 12px 15px;
            background: #143D39;
            border-bottom: 1px solid #20473d;

            .h {
                text-align: center;
                white-space: nowrap;
                color: #ccc;
                flex: 1;
            }

            .h:nth-child(1) {
                text-align: left;
            }
        }
    }

    .errs-msg {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 30px 20px;
        font-size: 14px;
        color: #77A092;
        font-weight: bold;
    }
}

.level-box {
    width: 100%;
    padding: 15px;
    height: fit-content;

    .title {
        width: 100%;
        display: flex;
        border: 1px solid #265245;
        border-radius: 10px;
        margin-bottom: 20px;
        background: #153932;

        .t {
            width: 25%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 2px;
            color: #DBE2E1;
            text-align: center;
            word-break: normal;
            /* 取消强制拆字符，恢复按单词换行 */
            word-wrap: break-word;
            /* 超长单词才拆行（避免溢出） */
            white-space: normal;
            /* 允许换行 */
        }
    }

    .lis {
        width: 100%;
        height: 130px;
        background: #153932;
        display: flex;
        border: 1px solid #265245;
        align-items: center;
        justify-content: center;
        padding: 8px 4px;
        color: #DBE2E1;
        border-radius: 10px;
        margin-top: 10px;

        .t {
            width: 25%;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px 4px;
            color: #DBE2E1;
        }

        .logos {
            display: block;
            width: 24px;
            height: 36px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            margin-right: 10px;
            color: #222;
            font-size: 10px;
            text-align: center;
            padding-top: 8px;
        }

        .t-boxs {
            width: 25%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 12px;

            .qq {
                display: block;
                padding: 2px 5px;
                border: 1px solid #526F6B;
                border-radius: 20px;
                margin: 4px 0px;

                .iconfont {
                    font-size: 10px;
                }
            }

            .yellow {
                color: #FCD34D;
                font-weight: bold;
                margin-bottom: 5px;
                font-size: 14px;
            }

            .green {
                color: #6AE1B2;
                font-weight: bold;
                margin-bottom: 5px;
                font-size: 14px;
            }
        }
    }
}

.jl-box {
    .back {
        background: transparent;
        border: none;
        color: #fff;
        font-size: 18px;
        margin-right: 15px;
    }

    .tab-boxs {
        width: 100%;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
            width: 24%;
            display: flex;
            align-items: center;
            justify-content: center;
            /* 垂直居中保留 */
            /* 去掉 justify-content: center，改用文本居中 + 换行 */
            padding: 12px 6px;
            background: #17332E;
            border: 1px solid #37524C !important;
            border-radius: 10px;

            word-break: normal;
            /* 取消强制拆字符，恢复按单词换行 */
            word-wrap: break-word;
            /* 超长单词才拆行（避免溢出） */
            white-space: normal;
            text-align: center;
            /* 允许换行 */
        }

        .active {
            background: #25C582;
            color: #2d2d2d;
        }
    }

    .btns {
        margin-left: auto;
        font-size: 14px;
        color: #C9CAA3;
    }

    .title-box h2 {
        font-size: 18px;
        color: #fff;
        margin: 0;
    }

    .uls-box {
        width: 100%;
        height: calc(100dvh - 50px);
        overflow: hidden;
        overflow-y: scroll;

        .lis {
            border: 1px solid #265245;
            background: #153932;
            padding: 10px;
            border-radius: 12px;
            margin-bottom: 12px;
            display: flex;
            flex-direction: column;

            .t {
                width: 100%;
                margin-bottom: 5px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 12px;

                span {
                    color: #E6F7EF;
                }

                span:last-child {
                    color: #eee;
                }
            }

            .t:last-child {
                margin-bottom: 0px;
            }
        }
    }

    /* 数据统计网格 */
    .stats-grid {
        width: 92%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .stats-item {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        padding: 15px;
        border: 1px solid #39675F;
    }

    .stats-label {
        font-size: 14px;
        color: #94BAAA;
        margin-bottom: 8px;
    }

    .stats-value {
        font-size: 20px;
        font-weight: 500;
    }

    /* 晋升奖励卡片 */
    .reward-card {
        width: 92%;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        margin: 0 15px 15px;
        padding: 15px;
        border: 1px solid #39675F;
    }

    .reward-label {
        font-size: 12px;
        color: #94BAAA;
        margin-bottom: 10px;
    }

    .reward-amount {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 8px;
    }

    .reward-total {
        font-size: 12px;
        color: #94BAAA;
        margin-bottom: 15px;
    }

    .withdraw-btn {
        color: #FFD700;
        font-size: 12px;
        font-weight: 500;
    }

    /* 每周表现卡片 */
    .weekly-card {
        width: 92%;
        background: linear-gradient(130deg, #fbbf2438, #10b98124 60%, #065f4633);
        border-radius: 12px;
        margin: 0 15px 15px;
        padding: 15px;
        border: 1px solid #39675F;
    }

    .weekly-title {
        font-size: 12px;
        color: #E9E4B8;
        margin-bottom: 10px;
    }

    .weekly-progress {
        margin-bottom: 8px;
    }

    .progress-text {
        font-size: 16px;
        font-weight: 500;
    }

    .weekly-period {
        font-size: 12px;
        color: #E9E4B8;
        margin-bottom: 12px;
    }

    .progress-bar {
        height: 6px;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 3px;
        margin-bottom: 12px;
        width: 100%;
        overflow: hidden;
    }

    .progress-inner {
        height: 100%;
        background: #34D399;
        border-radius: 3px;
    }

    .weekly-reward {
        font-size: 12px;
        color: #E9E4B8;
        margin-bottom: 8px;
    }

    .weekly-status {
        font-size: 12px;
        color: #ffffff;
    }

    /* 每日限额 */
    .daily-limit {
        width: 92%;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        margin: 0 15px 15px;
        padding: 15px;
        font-size: 12px;
        color: #94BAAA;
        border: 1px solid #39675F;
    }

    /* 提交区域 */
    .submit-section {
        width: 92%;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        margin: 0 15px 15px;
        padding: 15px;
        display: flex;
        flex-direction: column;
        border: 1px solid #39675F;

        input {
            width: 100%;
            height: 40px;
            padding: 0 10px;
            font-size: 14px;
            color: #ffffff;
        }
    }

    .submit-title {
        font-size: 12px;
        font-weight: bold;
        color: #C0E7D4;
        margin-bottom: 10px;
    }

    .submit-input {
        background: rgba(0, 0, 0, 0.2);
        border-radius: 8px;
        margin-bottom: 10px;
    }

    .submit-btn {
        background: #34D399;
        border: none;
        border-radius: 8px;
        color: #06241D;
        font-weight: 500;
        width: 100%;
        height: 40px;
        font-size: 14px;
    }

    /* 提交历史 */
    .history-section {
        width: 92%;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 8px;
        margin: 0 15px;
        border: 1px solid #39675F;
        overflow: hidden;

        .boxs {
            width: 100%;
            height: fit-content;
            overflow: hidden;
            overflow-x: scroll;
        }
    }

    .history-title {
        font-size: 12px;
        font-weight: 500;
        padding: 10px 15px;
        display: flex;
        align-items: center;
    }

    .history-tabs {
        width: fit-content;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        padding: 10px 15px;
        font-size: 12px;
        background: #0C2F27;
    }

    .history-li {
        width: fit-content;
        height: fit-content;
        padding: 10px 15px;
        color: #83AC9D;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #39675F;
    }

    .tab-item {
        display: block;
        font-size: 12px;
        color: #94BAAA;
        text-align: center;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
    }

    .tab-item:nth-child(1) {
        text-align: left;
    }
}

.psw_box {
    padding-top: 20px;
}

.keybord_box {
    height: 250px;
    background-color: #F0F0F0;
    margin-top: 35px;
    padding: 14px 12px 0 12px;
    margin: 0 auto;
    display: flex;
    justify-content: center;

    .keybord {
        width: 361px;
        margin: 24px auto 0 atuo;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        text-align: center;

        .key_item {
            width: 115px;
            height: 44px;
            line-height: 44px;
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 6px;
            background: rgba(255, 255, 255, 1);
            border-radius: 3px;

            .key_inner {
                color: #2d2d2d;
            }

            &.no_bg {
                background: none;
            }

            &.x {
                color: #757880;
                font-weight: bold;
            }
        }
    }
}

.qb-btn {
    font-size: 12px;
    padding: 6px 10px;
    border: 1px solid #274245;
    margin-top: 10px;
    border-radius: 8px;
    background: #152A32;
    color: #889198;
    margin-left: auto;
    display: flex;
    align-items: center;

    .iconfont {
        font-size: 10px;
    }
}

.logo-1 {
    background-image: url('../../assets/images/Lv/1.png');
}

.logo-2 {
    background-image: url('../../assets/images/Lv/2.png');
}

.logo-3 {
    background-image: url('../../assets/images/Lv/3.png');
}

.logo-4 {
    background-image: url('../../assets/images/Lv/4.png');
}

.logo-5 {
    background-image: url('../../assets/images/Lv/5.png');
}

.logo-6 {
    background-image: url('../../assets/images/Lv/6.png');
}

.logo-7 {
    background-image: url('../../assets/images/Lv/7.png');
}

.logo-8 {
    background-image: url('../../assets/images/Lv/8.png');
}

.logo-9 {
    background-image: url('../../assets/images/Lv/9.png');
}

.logo-10 {
    background-image: url('../../assets/images/Lv/10.png');
}

::v-deep .van-popup__close-icon {
    right: 5px;
    top: 5px;
}
</style>